module.exports = __webpack_public_path__ + "static/img/moreInfo2.05ff225.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ceramide/moreInfo2.png
// module id = 7B2f
// module chunks = 1